import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/duels/DuelCard.css';

/**
 * Карточка дуэли для списка
 * @param {Object} duel - Данные дуэли
 */
function DuelCard({ duel }) {
    const {
        id,
        title,
        description,
        coverImageId,
        format,
        roundType,
        status,
        creator,
        participantsCount,
        requiredParticipants,
        createdAt,
        startedAt,
        duelType
    } = duel;

    // Форматирование даты
    const formatDate = (dateString) => {
        if (!dateString) return '—';
        return new Date(dateString).toLocaleDateString('ru-RU', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };

    // Отображение формата
    const formatLabels = {
        SOLO: '1 на 1',
        TEAM_2V2: '2 на 2',
        TEAM_3V3: '3 на 3'
    };

    // Отображение типа раундов
    const roundTypeLabels = {
        SINGLE_ROUND: '1 раунд',
        BEST_OF_THREE: 'до 3 побед'
    };

    // Отображение типа дуэли
    const duelTypeLabels = {
        AUDIO: 'Аудио',
        TEXT: 'Текст',
        HYBRID: 'Аудио + Текст'
    };

    // Статусы
    const statusLabels = {
        PENDING_PARTICIPANTS: 'Ожидание участников',
        READY_TO_START: 'Готово к началу',
        IN_PROGRESS: 'В процессе',
        FINISHED: 'Завершено',
        CANCELLED: 'Отменено'
    };

    const statusColors = {
        PENDING_PARTICIPANTS: 'warning',
        READY_TO_START: 'info',
        IN_PROGRESS: 'success',
        FINISHED: 'secondary',
        CANCELLED: 'danger'
    };

    // URL обложки
    const coverUrl = coverImageId 
        ? `${process.env.REACT_APP_API_URL || 'https://api.hrnb.ru/api'}/files/${coverImageId}`
        : null;

    return (
        <div className="duel-card">
            {coverUrl && (
                <div className="duel-card__cover">
                    <img src={coverUrl} alt={title} className="duel-card__image" />
                    {duelType && (
                        <span className="duel-card__type-badge">
                            {duelTypeLabels[duelType] || duelType}
                        </span>
                    )}
                </div>
            )}
            
            <div className="duel-card__body">
                <div className="duel-card__header">
                    <span className={`duel-card__status duel-card__status--${statusColors[status]}`}>
                        {statusLabels[status] || status}
                    </span>
                    <span className="duel-card__format">
                        {formatLabels[format]} • {roundTypeLabels[roundType]}
                    </span>
                </div>

                <h3 className="duel-card__title">
                    <Link to={`/duels/${id}`} className="duel-card__link">
                        {title}
                    </Link>
                </h3>

                {description && (
                    <p className="duel-card__description">{description}</p>
                )}

                <div className="duel-card__footer">
                    <div className="duel-card__participants">
                        <span className="duel-card__participants-count">
                            {participantsCount} / {requiredParticipants}
                        </span>
                        <span className="duel-card__participants-label">участников</span>
                    </div>

                    <div className="duel-card__meta">
                        <span className="duel-card__creator">
                            Создатель: <strong>{creator?.nickname || creator?.name || '—'}</strong>
                        </span>
                        <span className="duel-card__date">
                            {status === 'IN_PROGRESS' 
                                ? `Начало: ${formatDate(startedAt)}`
                                : `Создано: ${formatDate(createdAt)}`
                            }
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DuelCard;
